<template>
    <v-container class="mw-400" v-if="token">
      <v-card elevation="2">
        <v-card-title class="tableheader white--text">
          <v-icon left color="white">mdi-lock-reset</v-icon>
          Choose a new password
        </v-card-title>
        <v-card-text>
          <v-form ref="frm" v-model="valid" @submit.prevent="submit">
            <v-text-field v-model="pwd"  type="password" label="New password"      :rules="[rules.req, rules.len]" variant="outlined"/>
            <v-text-field v-model="pwd2" type="password" label="Confirm password" :rules="[rules.req, v=>v===pwd||'Mismatch']" variant="outlined"/>
            <v-btn type="submit" color="primary" :loading="loading" :disabled="!valid">Reset</v-btn>
          </v-form>
          <v-alert v-if="msg" class="mt-4" :type="alertType" border="start">{{ msg }}</v-alert>
        </v-card-text>
      </v-card>
    </v-container>
  
    <v-container v-else>
      <v-alert type="error" border="start">Reset token missing.</v-alert>
    </v-container>
  </template>
  
  <script setup>
  import { ref } from 'vue'; import { useRoute, useRouter } from 'vue-router'; import api from '@/services/api';
  const route=useRoute(), router=useRouter(); const token=route.query.token||''
  const pwd=ref(''),pwd2=ref(''),valid=ref(false),loading=ref(false),msg=ref(''),alertType=ref('info')
  const rules={req:v=>!!v||'Required',len:v=>v.length>=8||'Min 8 chars'}
  async function submit(){
    loading.value=true
    try{
      await api.post('/api/auth/reset-password',{token,password:pwd.value})
      msg.value='Password updated – you may now log in.'; alertType.value='success'
      setTimeout(()=>router.push('/login'),2500)
    }catch(e){
      msg.value=e.response?.data?.error||'Reset failed'; alertType.value='error'
    }finally{loading.value=false}
  }
  </script>
  